import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import { forkJoin } from "rxjs";
import { filter } from "rxjs/operators";
import { FilterModel } from "src/app/shared/components/filter/model/filter.model";
import { SNACKBAR_CLASS } from "src/app/shared/components/snackbar/model/snackbar.model";
import { SnackbarService } from "src/app/shared/components/snackbar/service/snackbar.service";
import { Column } from "src/app/shared/components/table/model/column";
import { Table } from "src/app/shared/components/table/model/table";
import { TableUtilityService } from "src/app/shared/components/table/service/utility/table-utility.service";
import { I18nService } from "src/app/shared/i18n/service/i18n.service";
import { SearchParams } from "src/app/shared/model/searchParams";
import { TableApiService } from "src/app/shared/service/api/table-api.service";
import { CsManagementService } from "src/app/shared/service/store-management/cs-management/cs-management.service";
import { SubSink } from "subsink";
import { CustomerChooseService } from "../service/customer-choose.service";
import { CustomerChooseMapService } from "../service/map/customer-choose-map.service";
import { AdministrationService } from "src/app/feature/administration/service/administration.service";
import { FileUtilService } from "src/app/shared/service/file-util/file-util.service";
import { MimeTypes } from "src/app/shared/components/upload-file-dnd/model/mimeTypes";
import { DateUtilService } from "src/app/shared/service/date-util/date-util.service";
import { CustomerRequestExport } from "../model/cs.model";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";
import { FilterComponent } from "src/app/shared/components/filter/filter.component";
import { TableComponent } from "src/app/shared/components/table/table.component";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "src/app/shared/module/material.module";
@Component({
    selector: "ald-customer-table",
    templateUrl: "./customer-table.component.html",
    styleUrls: ["./customer-table.component.scss"],
    imports: [
        I18nPipe,
        FilterComponent,
        TableComponent,
        CommonModule,
        MaterialModule
    ]
})
export class CustomerTableComponent implements OnChanges {
  @Input() cSModelRetrieved;
  table: Table = {} as Table;
  searchParams: SearchParams;
  filters: FilterModel;
  appliedFilters = {} as any;
  page = "contacts";
  columns: Array<Column>;
  private subs: SubSink = new SubSink();
  @Output() selectedCs = new EventEmitter();
  @Output() reset = new EventEmitter();
  constructor(
    private tableApi: TableApiService,
    private tableUtility: TableUtilityService,
    private customerChooseService: CustomerChooseService,
    private csmanagementService: CsManagementService,
    private customerChooseMapService: CustomerChooseMapService,
    private snack: SnackbarService,
    private i18n: I18nService,
    private administrationService: AdministrationService,
    private fileUtil: FileUtilService,
    private dateUtil: DateUtilService,
  ) {}

  searchAgain(){
    this.reset.emit(null)
  }

  ngOnChanges(): void {
    console.log(this.cSModelRetrieved);
    this.defineSearchParams();
    this.initTable();
  }

  initTable(): void {
    // tslint:disable-next-line: variable-name
    const $list_vehicle_table_api = [
      this.tableApi.getFilters(this.page),
      this.tableApi.getColumnsByName(`contacts-list`),
    ];
    this.subs.add(
      forkJoin($list_vehicle_table_api)
        .pipe(filter((res) => !!res))
        .subscribe((forkedRes: any) => {
          const { contactsFilters } = forkedRes[0];
          this.filters =
            this.tableUtility.getDefaultFilterModel(contactsFilters);
          const { contactsListColumns } = forkedRes[1];
          this.columns =
            this.tableUtility.prepareToTranslation(contactsListColumns);
          this.searchContacts();
        })
    );
  }

  private searchContacts(): void {
    this.subs.add(
      this.customerChooseService
        .contacts(this.searchParams, this.appliedFilters)
        .pipe(filter((res) => !!res))
        .subscribe((resp: any) => {
          const { totElements, contacts } = resp;
          this.loadTable(this.columns, contacts, totElements);
        })
    );
  }

  private loadTable(
    columns: Array<Column>,
    data: Array<any>,
    totalElements: number
  ): void {
    this.table = {} as Table;
    this.table = this.tableUtility.getResponseToTable(
      columns,
      this.customerChooseMapService.cs2ChooseMap(data),
      totalElements
    );
  }

  private defineSearchParams(): void {
    this.appliedFilters.customerRef = JSON.stringify(
      this.csmanagementService.getCustomerServiceByStore().customer_id
    );
    this.appliedFilters.active = true;
    this.searchParams = {
      page: 1,
      pageSize: 10,
    };
  }

  selectionCustomer(row) {
    if (!!row.csChoosen.externalId) {
      this.selectedCs.emit(row.csChoosen);
    } else {
      this.snack.openSnackReferClassWithoutTranslate(
        this.i18n.getTranslation('no_contact_selected'),
        SNACKBAR_CLASS.WARNING_CLASS
      );
    }
  }

  onPageChangeEvent(pageSelected): void {
    this.searchParams.page = pageSelected;
    this.searchContacts();
  }

  onSortSelected(sortSelected): void {
    this.searchParams.orderBy = sortSelected.active;
    this.searchParams.asc = sortSelected.direction === "asc";
    this.searchContacts();
  }

  search(resFilter): void {
    this.appliedFilters.searchGuid = resFilter.searchGuid;
    //this.appliedFilters.active = resFilter.status?.some((x) => x === "active");
    this.appliedFilters.active = true;
    this.appliedFilters.customerRef = JSON.stringify(
      this.csmanagementService.getCustomerServiceByStore().customer_id
    );
    this.searchParams.page = 1;
    this.searchContacts();
  }

   onExportCustomerList(isFiltered): void{
    // const filters = isFiltered
    //   ? this.appliedFilters
    //   : ({
    //     searchGuid: null,
    //     status: null,
    //   } as any);
      const body = isFiltered
      ? this.appliedFilters
      : ({
        active: true,
        customerRef : JSON.stringify(
          this.csmanagementService.getCustomerServiceByStore().customer_id
        ),
        customerId: null,
        contactId: null,
        identification: null,
        name: null,
        surname: null,
        role: null,
        searchGuid: null,
      } as CustomerRequestExport);
    const searchParamsExport = {
      ...this.searchParams,
    } as SearchParams;
    delete searchParamsExport.page;
    delete searchParamsExport.pageSize;
    this.subs.add(
      this.administrationService
        .getCustomersListExport(searchParamsExport, body)
        .pipe(filter((res) => !!res))
        .subscribe((data) =>
          this.fileUtil.downloadFile(
            data,
            MimeTypes.excel,
            `customersList_${this.dateUtil.getNowFormatted(
              "DD_MM_YYYY_hh_mm"
            )}.xlsx`
          )
        )
    );

   }
}
